// extracted by mini-css-extract-plugin
export default {"UserAvatar":"UserAvatar-module-f5deaa4132cbf00164a0"};